var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAntlogyHomeGridIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 800,
    zoomAndPan: "magnify",
    viewBox: "0 0 600 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "f494cdc042"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 29.777344 21.734375 L 86.042969 21.734375 L 86.042969 172.515625 L 29.777344 172.515625 Z M 29.777344 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ada9dc5d77"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 52.277344 21.734375 L 63.542969 21.734375 C 69.511719 21.734375 75.234375 24.105469 79.453125 28.324219 C 83.675781 32.542969 86.042969 38.265625 86.042969 44.234375 L 86.042969 149.976562 C 86.042969 155.945312 83.675781 161.667969 79.453125 165.886719 C 75.234375 170.109375 69.511719 172.476562 63.542969 172.476562 L 52.277344 172.476562 C 46.308594 172.476562 40.585938 170.109375 36.367188 165.886719 C 32.148438 161.667969 29.777344 155.945312 29.777344 149.976562 L 29.777344 44.234375 C 29.777344 38.265625 32.148438 32.542969 36.367188 28.324219 C 40.585938 24.105469 46.308594 21.734375 52.277344 21.734375 Z M 52.277344 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ef504ef7d3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.777344 0.734375 L 57.042969 0.734375 L 57.042969 151.515625 L 0.777344 151.515625 Z M 0.777344 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f43e29a6c8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.277344 0.734375 L 34.542969 0.734375 C 40.511719 0.734375 46.234375 3.105469 50.453125 7.324219 C 54.675781 11.542969 57.042969 17.265625 57.042969 23.234375 L 57.042969 128.976562 C 57.042969 134.945312 54.675781 140.667969 50.453125 144.886719 C 46.234375 149.109375 40.511719 151.476562 34.542969 151.476562 L 23.277344 151.476562 C 17.308594 151.476562 11.585938 149.109375 7.367188 144.886719 C 3.148438 140.667969 0.777344 134.945312 0.777344 128.976562 L 0.777344 23.234375 C 0.777344 17.265625 3.148438 11.542969 7.367188 7.324219 C 11.585938 3.105469 17.308594 0.734375 23.277344 0.734375 Z M 23.277344 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eb2feda248"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 58,
    y: 0,
    height: 152
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0ec9c5b9cb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 115.179688 21.089844 L 281.023438 21.089844 L 281.023438 353.414062 L 115.179688 353.414062 Z M 115.179688 21.089844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ec345a0bb7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 138.328125 21.734375 L 258.523438 21.734375 C 264.488281 21.734375 270.210938 24.105469 274.429688 28.324219 C 278.652344 32.542969 281.023438 38.265625 281.023438 44.234375 L 281.023438 330.765625 C 281.023438 336.734375 278.652344 342.457031 274.429688 346.675781 C 270.210938 350.894531 264.488281 353.265625 258.523438 353.265625 L 138.328125 353.265625 C 132.359375 353.265625 126.636719 350.894531 122.417969 346.675781 C 118.195312 342.457031 115.828125 336.734375 115.828125 330.765625 L 115.828125 44.234375 C 115.828125 38.265625 118.195312 32.542969 122.417969 28.324219 C 126.636719 24.105469 132.359375 21.734375 138.328125 21.734375 Z M 138.328125 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9669b0535e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.679688 0.601562 L 166.023438 0.601562 L 166.023438 332.28125 L 0.679688 332.28125 Z M 0.679688 0.601562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "919c9fd990"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.328125 0.734375 L 143.523438 0.734375 C 149.488281 0.734375 155.210938 3.105469 159.429688 7.324219 C 163.652344 11.542969 166.023438 17.265625 166.023438 23.234375 L 166.023438 309.765625 C 166.023438 315.734375 163.652344 321.457031 159.429688 325.675781 C 155.210938 329.894531 149.488281 332.265625 143.523438 332.265625 L 23.328125 332.265625 C 17.359375 332.265625 11.636719 329.894531 7.417969 325.675781 C 3.195312 321.457031 0.828125 315.734375 0.828125 309.765625 L 0.828125 23.234375 C 0.828125 17.265625 3.195312 11.542969 7.417969 7.324219 C 11.636719 3.105469 17.359375 0.734375 23.328125 0.734375 Z M 23.328125 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1d25c3b4aa"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 167,
    y: 0,
    height: 333
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ee778f975f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 310.804688 21.734375 L 570.222656 21.734375 L 570.222656 354 L 310.804688 354 Z M 310.804688 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e4188ff51a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 333.304688 21.734375 L 547.722656 21.734375 C 553.691406 21.734375 559.414062 24.105469 563.632812 28.324219 C 567.851562 32.542969 570.222656 38.265625 570.222656 44.234375 L 570.222656 330.765625 C 570.222656 336.734375 567.851562 342.457031 563.632812 346.675781 C 559.414062 350.894531 553.691406 353.265625 547.722656 353.265625 L 333.304688 353.265625 C 327.335938 353.265625 321.613281 350.894531 317.394531 346.675781 C 313.171875 342.457031 310.804688 336.734375 310.804688 330.765625 L 310.804688 44.234375 C 310.804688 38.265625 313.171875 32.542969 317.394531 28.324219 C 321.613281 24.105469 327.335938 21.734375 333.304688 21.734375 Z M 333.304688 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "204512c9bd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.804688 0.734375 L 260.222656 0.734375 L 260.222656 332.28125 L 0.804688 332.28125 Z M 0.804688 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8db9f3f9b2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.304688 0.734375 L 237.722656 0.734375 C 243.691406 0.734375 249.414062 3.105469 253.632812 7.324219 C 257.851562 11.542969 260.222656 17.265625 260.222656 23.234375 L 260.222656 309.765625 C 260.222656 315.734375 257.851562 321.457031 253.632812 325.675781 C 249.414062 329.894531 243.691406 332.265625 237.722656 332.265625 L 23.304688 332.265625 C 17.335938 332.265625 11.613281 329.894531 7.394531 325.675781 C 3.171875 321.457031 0.804688 315.734375 0.804688 309.765625 L 0.804688 23.234375 C 0.804688 17.265625 3.171875 11.542969 7.394531 7.324219 C 11.613281 3.105469 17.335938 0.734375 23.304688 0.734375 Z M 23.304688 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "305efeb554"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 261,
    y: 0,
    height: 333
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f8d59ae355"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 29.777344 202.523438 L 86.042969 202.523438 L 86.042969 353.300781 L 29.777344 353.300781 Z M 29.777344 202.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "da4ae4cf6a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 52.277344 202.523438 L 63.542969 202.523438 C 69.511719 202.523438 75.234375 204.890625 79.453125 209.113281 C 83.675781 213.332031 86.042969 219.054688 86.042969 225.023438 L 86.042969 330.765625 C 86.042969 336.734375 83.675781 342.457031 79.453125 346.675781 C 75.234375 350.894531 69.511719 353.265625 63.542969 353.265625 L 52.277344 353.265625 C 46.308594 353.265625 40.585938 350.894531 36.367188 346.675781 C 32.148438 342.457031 29.777344 336.734375 29.777344 330.765625 L 29.777344 225.023438 C 29.777344 219.054688 32.148438 213.332031 36.367188 209.113281 C 40.585938 204.890625 46.308594 202.523438 52.277344 202.523438 Z M 52.277344 202.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d0acd11894"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.777344 0.523438 L 57.042969 0.523438 L 57.042969 151.28125 L 0.777344 151.28125 Z M 0.777344 0.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8fc7c90152"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.277344 0.523438 L 34.542969 0.523438 C 40.511719 0.523438 46.234375 2.890625 50.453125 7.113281 C 54.675781 11.332031 57.042969 17.054688 57.042969 23.023438 L 57.042969 128.765625 C 57.042969 134.734375 54.675781 140.457031 50.453125 144.675781 C 46.234375 148.894531 40.511719 151.265625 34.542969 151.265625 L 23.277344 151.265625 C 17.308594 151.265625 11.585938 148.894531 7.367188 144.675781 C 3.148438 140.457031 0.777344 134.734375 0.777344 128.765625 L 0.777344 23.023438 C 0.777344 17.054688 3.148438 11.332031 7.367188 7.113281 C 11.585938 2.890625 17.308594 0.523438 23.277344 0.523438 Z M 23.277344 0.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "791c61496c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 58,
    y: 0,
    height: 152
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f494cdc042)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ada9dc5d77)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 29, 21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eb2feda248)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ef504ef7d3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f43e29a6c8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.777344 0.734375 L 57.042969 0.734375 L 57.042969 151.515625 L 0.777344 151.515625 Z M 0.777344 0.734375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0ec9c5b9cb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ec345a0bb7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 115, 21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1d25c3b4aa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9669b0535e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#919c9fd990)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.828125 0.734375 L 166.023438 0.734375 L 166.023438 332.414062 L 0.828125 332.414062 Z M 0.828125 0.734375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ee778f975f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e4188ff51a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 310, 21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#305efeb554)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#204512c9bd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8db9f3f9b2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.804688 0.734375 L 260.222656 0.734375 L 260.222656 332.101562 L 0.804688 332.101562 Z M 0.804688 0.734375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f8d59ae355)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#da4ae4cf6a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 29, 202)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#791c61496c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d0acd11894)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8fc7c90152)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.777344 0.523438 L 57.042969 0.523438 L 57.042969 151.300781 L 0.777344 151.300781 Z M 0.777344 0.523438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntlogyHomeGridIcon2);
export default __webpack_public_path__ + "static/media/antlogyHomeGridIcon2.d1a4231f0fdcbced3125bdebb1e75fa6.svg";
export { ForwardRef as ReactComponent };